/* eslint-disable react/require-default-props */
import React from 'react';
import { Button } from '../../../../atoms/Button/Button';
import { AttachMenu } from '../AttachMenu';
import { AudioRecorder } from '../AudioRecorder';
import { useAIInput } from '../../AIInputContext';
import './FooterActionsStyles.scss';
/**
 * FooterActions Component
 * Left side: attach menu (+). Right side: record audio (mic) + submit (arrow).
 * @version 1.0.0
 * @since 2026-02-17
 */
export function FooterActions({ enableVoiceRecording = false, disabled = false, allowedFormats, isLoading = false, allowAttachments = true, onSubmit, onStop }) {
    const baseClass = 'qmb-ui-ai-input-footer';
    const { addAttachments } = useAIInput();
    const handleRecordingComplete = (file) => {
        addAttachments([file]);
    };
    return (React.createElement("div", { className: baseClass },
        React.createElement("div", { className: `${baseClass}__left` }, allowAttachments ? React.createElement(AttachMenu, { allowedFormats: allowedFormats }) : null),
        React.createElement("div", { className: `${baseClass}__right` },
            enableVoiceRecording && allowAttachments ? (React.createElement(AudioRecorder, { onRecordingComplete: handleRecordingComplete, baseClass: baseClass })) : null,
            React.createElement(Button, { variant: "primary", "aria-label": isLoading ? 'Stop' : 'Submit', disabled: isLoading ? false : disabled, onClick: isLoading ? onStop : onSubmit },
                React.createElement("i", { className: isLoading ? 'fa-solid fa-stop' : 'fa-light fa-arrow-up' })))));
}
